import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import Image from 'next/image';
import { Colors, DesktopPaddingLarger, MobilePadding } from 'pages';
import { FC } from 'react';
import { ContainerMaxWidth } from './organisms/layouts/Layout';
const Card: FC<{
  title: string;
  description: string;
  number: number;
}> = ({
  title,
  description,
  number
}) => {
  return <Box sx={{
    backgroundColor: '#D6EAFF',
    borderRadius: '2px',
    padding: '24px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  }}>
      <Typography sx={{
      color: '#3547C5',
      fontSize: '24px',
      fontWeight: 700,
      mb: '8px'
    }}>
        {number}.
      </Typography>
      <Typography sx={{
      color: '#1D202A',
      fontSize: '20px',
      fontWeight: 700,
      mb: '16px'
    }}>
        {title}
      </Typography>
      <Typography sx={{
      color: '#44485A',
      fontSize: '16px',
      fontWeight: 400,
      flex: 1
    }}>
        {description}
      </Typography>
    </Box>;
};
export const Barriers: React.FC = () => {
  return <Box sx={{
    padding: {
      xs: MobilePadding,
      md: DesktopPaddingLarger
    },
    height: '100%',
    width: '100%',
    maxWidth: ContainerMaxWidth,
    display: 'flex',
    flexDirection: 'column',
    mx: 'auto',
    alignItems: 'center',
    justifyContent: 'center'
  }}>
      <Box sx={{
      maxWidth: '1200px',
      mx: 'auto'
    }}>
        <Typography sx={{
        fontSize: '38px',
        fontWeight: 700,
        textAlign: 'center',
        lineHeight: {
          xs: 1.2,
          md: 1.5
        },
        mb: {
          xs: 2,
          md: 1
        }
      }}>
          Breaking Down Barriers to EV Adoption
        </Typography>
        <Typography sx={{
        fontSize: '16px',
        color: Colors.RiverBed,
        textAlign: 'center',
        mt: '1rem',
        mb: {
          xs: 3,
          md: 4
        }
      }}>
          Dealerships face three challenges they must overcome for consumers
        </Typography>
      </Box>

      <Box sx={{
      display: 'flex',
      flexDirection: {
        xs: 'column',
        md: 'row'
      },
      justifyContent: 'space-between',
      gap: {
        xs: '16px',
        md: '24px'
      },
      mx: 'auto'
    }}>
        <Box sx={{
        width: {
          xs: '100%',
          md: '32%'
        }
      }}>
          <Card title="Affordability" description="Perception that EV prices are out of reach." number={1} />
        </Box>
        <Box sx={{
        width: {
          xs: '100%',
          md: '32%'
        }
      }}>
          <Card title="Range anxiety" description="Concerns surrounding EV travel for daily trips and road trips." number={2} />
        </Box>
        <Box sx={{
        width: {
          xs: '100%',
          md: '32%'
        }
      }}>
          <Card title="Access to charging" description="Uncertainty about home and public charging options." number={3} />
        </Box>
      </Box>

      <Box sx={{
      mt: '24px',
      display: 'flex',
      flexDirection: {
        xs: 'column',
        md: 'row'
      },
      alignItems: 'stretch',
      justifyContent: 'space-between',
      gap: '24px'
    }}>
        <Box sx={{
        width: {
          xs: '100%',
          md: '100%'
        },
        border: '1px solid #C9E7D2',
        padding: '16px'
      }}>
          <Box sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          mb: '1rem'
        }}>
            <Image src="/assets/images/lightbulb.svg" width={16} height={22} alt="Lightbulb Icon" />
          </Box>
          <Typography sx={{
          fontSize: '20px',
          color: '#1D202A',
          textAlign: 'left',
          fontWeight: 'bold',
          mb: '16px'
        }}>
            Lectrium solution
          </Typography>
          <Typography sx={{
          fontSize: '16px',
          color: '#44485A',
          textAlign: 'left'
        }}>
            At Lectrium, we provide tailored solutions to address these barriers. From tools that demystify pricing and
            financing to resources that educate on charging and range capabilities, our products empower you to build
            trust and confidence with every customer.
          </Typography>
        </Box>
        <Box>
          <Image src={`/assets/images/lectrium_solution.png`} alt="Lectrium" width={1000} height={1000} style={{
          width: '100%',
          maxWidth: '100%',
          height: '100%'
        }} />
        </Box>
      </Box>
    </Box>;
};